export default function IntroVideoPopup({ onOpen }) {
  return (
    <div className="intro-popup-center">
      <p>Welcome to PacketGPT!</p>
      <button onClick={onOpen} className="intro-watch-btn">
        ▶ Watch Intro Video
      </button>
    </div>
  );
}
